const BUILDER_LAST_NAME_SUFFIX = "BUILDER";

type OfferWithCustomerName = {
  customerName: string;
};

function getCustomerLastNameFromOffer(customerName: string): string {
  const trimmed = customerName.trim();
  const spaceIndex = trimmed.indexOf(" ");

  if (spaceIndex === -1) {
    return "";
  }

  return trimmed.slice(spaceIndex + 1);
}

function isBuilderOffer(offer: OfferWithCustomerName): boolean {
  if (!offer.customerName) {
    return false;
  }

  const lastName = getCustomerLastNameFromOffer(offer.customerName);

  return lastName.toUpperCase().endsWith(BUILDER_LAST_NAME_SUFFIX);
}

function excludeBuilderOffers<T extends OfferWithCustomerName>(
  offers: T[]
): T[] {
  return offers.filter((offer) => !isBuilderOffer(offer));
}

export {
  BUILDER_LAST_NAME_SUFFIX,
  excludeBuilderOffers,
  getCustomerLastNameFromOffer,
  isBuilderOffer,
};
